export class UserDetails {

    constructor(public associatedApps: string,
        public email: string, public firstName: string,
        public lastName: string, public telephoneNumber: string,
        public userId: string, public userName: string,
        public userPassword: string, public userStatus: string) {
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/userManagement/user-details.ts
 **/